export default {
  exportExcel: '导出 Excel',
  exportUsername: '用户名',
  exportContact: '邮箱/手机号',
  exportEmpty: '当前筛选条件下没有可导出的记录',
  exportFailed: '导出失败，请稍后重试',
  pageTitle: '用户列表',
  overviewTitle: '会员订阅数据概览',
  statTotal: '订阅企业总数',
  statMonthNew: '本月新增',
  statMonthRenewal: '本月续费收入',
  statAveragePlanValue: '平均套餐价值',
  planDistribution: '套餐分布',
  tabAll: '全部会员',
  tabNormal: '普通会员',
  tabPaid: '付费会员',
  tabCustom: '定制版',
  tabCustomMember: '定制会员',
  searchPlaceholder: '搜索企业名称 / 联系人 / 手机',
  expireAll: '到期时间：全部',
  expireSoon30: '30天内到期',
  expireSoon90: '90天内到期',
  expireExpired: '已过期',
  colMemberNo: '会员编号',
  colCompany: '企业/组织名称',
  colContact: '联系人',
  colPhone: '手机号',
  colPlan: '当前套餐',
  colExpire: '到期时间',
  colActivities: '已建活动',
  viewDetail: '查看详情',
  adjustPlan: '调整套餐',
  permanent: '永久',
  grantTitle: '调整套餐',
  grantHint: '为「{name}」开通或更换套餐（免支付，立即替换）。',
  grantPick: '选择套餐',
  grantConfirm: '确定调整',
  grantSuccess: '已调整套餐',
  crumbPrefix: '当前位置：',
  basicInfo: '基础信息',
  verificationAndPermissions: '认证与权限',
  accountStatus: '账户状态',
  accountNormal: '正常',
  permissionNormal: '正常',
  permissionExpired: '已到期',
  registerSource: '注册来源',
  sourceAdmin: '后台开通',
  sourcePurchase: '自助购买',
  sourceFallback: '到期回落',
  sourceUnknown: '后台创建',
  activityCount: '{n} 个'
}
